import { type SpacingToken, s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives/types';

type DataStateMessageFrameOptions = {
  variant: 'table' | 'card';
};

type ErrorStatePanelStackOptions = {
  align?: 'center';
};

export const buildDataStateMessageFrameSx = ({
  variant,
}: DataStateMessageFrameOptions): SxProps<Theme> => {
  const paddingToken: SpacingToken = variant === 'card' ? 'lg' : 'md';
  const resolvedPadding = s(paddingToken);

  return {
    px: resolvedPadding,
    py: resolvedPadding,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
};

export const EMPTY_STATE_CONTENT_SX = {
  display: 'grid',
  gap: s('sm'),
  justifyItems: 'center',
} as const;

export const EMPTY_STATE_ICON_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: s('xl'),
  lineHeight: 0,
  color: 'text.secondary',
} as const;

export const EMPTY_STATE_TITLE_SX = {
  fontWeight: 400,
} as const;

export const EMPTY_STATE_ACTION_SX = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: s('xs'),
  marginTop: s('sm'),
} as const;

export const EMPTY_STATE_BODY_SX = {
  textAlign: 'center',
} as const;

export const EMPTY_STATE_CENTER_SX = {
  textAlign: 'center',
} as const;

export const buildErrorStatePanelStackSx = ({
  align = 'center',
}: ErrorStatePanelStackOptions = {}): SxProps<Theme> => ({
  width: '100%',
  textAlign: align,
});

export const ERROR_STATE_PANEL_TITLE_ROW_SX = {
  width: 'auto',
  maxWidth: '100%',
  alignItems: 'center',
} as const;

export const ERROR_STATE_PANEL_TITLE_SX = {
  minWidth: 0,
  textAlign: 'left',
} as const;

export const ERROR_STATE_PANEL_BODY_SX = {
  textAlign: 'center',
} as const;
